// InventoryOutputAPI.js
import { axiosInstance } from "../../../Services";

// Add new output/design file
export const AddInventoryOutput = async (id, data) => {
  try {
    const res = await axiosInstance.post(
      `/rsform/inventories/design/${id}`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          "x-api-key": localStorage.getItem("token"),
        },
      }
    );
    return res.data; // return API response
  } catch (err) {
    throw err;
  }
};

// Get all output/design files for an inventory
export const GetInventoryOutputs = async (id) => {
  try {
    const res = await axiosInstance.get(`/rsform/inventories/output/${id}`, {
      headers: {
        "x-api-key": localStorage.getItem("token"),
      },
    });
    return res.data?.data; // return array of outputs
  } catch (err) {
    throw err;
  }
};

// Approve / Reject an output (design approval)
// approval_status: "approved" | "declined"
// approval_comment: optional
export const ApproveInventoryOutput = async (
  versionId,
  outputId,
  { approval_status, approval_comment }
) => {
  try {
    const formData = new FormData();
    formData.append("approval_status", approval_status);
    formData.append("approval_type", "output");
    if (approval_comment) {
      formData.append("approval_comment", approval_comment);
    }

    const res = await axiosInstance.post(
      `/rsform/inventories/designApproval/${versionId}/${outputId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          "x-api-key": localStorage.getItem("token"),
        },
      }
    );
    return res.data;
  } catch (err) {
    throw err;
  }
};

// Send selected outputs to client (generate template)
export const GenerateOutputTemplate = async (versionId, outputIds) => {
  try {
    const res = await axiosInstance.post(
      `/rsform/inventories/generate_pdf_template/${versionId}`,
      { outputs: outputIds },
      {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": localStorage.getItem("token"),
        },
      }
    );
    return res.data;
  } catch (err) {
    throw err;
  }
};